import Map from '@Pages/Map/Map';
import MapOutlined from '@mui/icons-material/MapOutlined';
import MapRedirect from '@Pages/MapRedirect/MapRedirect';
import React from 'react';
import { addRouteNamespace } from '@Utils/actions';

export const mainPageRoutes = [
	{
		title: 'Network',
		to: addRouteNamespace(''),
		path: addRouteNamespace(':background?/:center?/:zoom?/:selectedItems?'),
		icon: <MapOutlined />,
		render: <Map />,
		dataCy: 'sidebar-network-button',
	},
];

export const miniPageRoutes = [
	{
		title: 'Home',
		to: '/',
		render: <MapRedirect />,
	},
	...mainPageRoutes,
];

export default [mainPageRoutes, miniPageRoutes];
